import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessCardApiService {
  constructor(private http: HttpClient) {}

  getAccessCardApiResponse(): Observable<Blob> {
    return this.http.get('/api/backoffice/v2/customer_portal/door_opener_qr_code/', { responseType: 'blob' });
  }
}
